import { useEffect, useState, useCallback } from "react";
import { apiClient } from "@/lib/api";
import { toast } from "sonner";

export function usePagedList(endpoint, params = {}, deps = []) {
  const [data, setData] = useState({ items: [], total: 0, total_pages: 0 });
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [loading, setLoading] = useState(true);
  const [extra, setExtra] = useState({});

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await apiClient.get(endpoint, { params: { page, page_size: pageSize, ...params } });
      setData(res.data);
      const { items, total, total_pages, ...rest } = res.data;
      setExtra(rest);
    } catch {
      toast.error("Erreur de chargement");
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endpoint, page, pageSize, ...deps]);

  useEffect(() => { fetchData(); }, [fetchData]);
  useEffect(() => { setPage(1); }, deps); // eslint-disable-line react-hooks/exhaustive-deps

  return { ...data, extra, page, setPage, pageSize, setPageSize, loading, refresh: fetchData };
}
